import { render, staticRenderFns } from "./MasterDevelopments.vue?vue&type=template&id=4d64ff26"
import script from "./MasterDevelopments.vue?vue&type=script&lang=js"
export * from "./MasterDevelopments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports